import React from 'react'

export default () => (
  <svg viewBox="0 0 24 24">
    <path d="M17.512 7.263L9.375 15.4l-2.888-2.888a.846.846 0 00-1.224 0 .846.846 0 000 1.226l3.5 3.5c.175.175.35.262.612.262a.794.794 0 00.613-.262l8.75-8.75a.846.846 0 000-1.225.846.846 0 00-1.226 0z"/>
  </svg>
)
